/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateWearablePermissionAuditLogDto
 */
export interface CreateWearablePermissionAuditLogDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWearablePermissionAuditLogDto
     */
    providerCode: CreateWearablePermissionAuditLogDtoProviderCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateWearablePermissionAuditLogDto
     */
    eventType: CreateWearablePermissionAuditLogDtoEventTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWearablePermissionAuditLogDto
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateWearablePermissionAuditLogDto
     */
    permissionStatus: CreateWearablePermissionAuditLogDtoPermissionStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof CreateWearablePermissionAuditLogDto
     */
    metadata?: object;
}


/**
 * @export
 */
export const CreateWearablePermissionAuditLogDtoProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type CreateWearablePermissionAuditLogDtoProviderCodeEnum = typeof CreateWearablePermissionAuditLogDtoProviderCodeEnum[keyof typeof CreateWearablePermissionAuditLogDtoProviderCodeEnum];

/**
 * @export
 */
export const CreateWearablePermissionAuditLogDtoEventTypeEnum = {
    ToggleOnRequested: 'toggle_on_requested',
    ToggleOffConfirmed: 'toggle_off_confirmed',
    PermissionResult: 'permission_result'
} as const;
export type CreateWearablePermissionAuditLogDtoEventTypeEnum = typeof CreateWearablePermissionAuditLogDtoEventTypeEnum[keyof typeof CreateWearablePermissionAuditLogDtoEventTypeEnum];

/**
 * @export
 */
export const CreateWearablePermissionAuditLogDtoPermissionStatusEnum = {
    Granted: 'granted',
    Partial: 'partial',
    Denied: 'denied',
    Unknown: 'unknown'
} as const;
export type CreateWearablePermissionAuditLogDtoPermissionStatusEnum = typeof CreateWearablePermissionAuditLogDtoPermissionStatusEnum[keyof typeof CreateWearablePermissionAuditLogDtoPermissionStatusEnum];


/**
 * Check if a given object implements the CreateWearablePermissionAuditLogDto interface.
 */
export function instanceOfCreateWearablePermissionAuditLogDto(value: object): value is CreateWearablePermissionAuditLogDto {
    if (!('providerCode' in value) || value['providerCode'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('permissionStatus' in value) || value['permissionStatus'] === undefined) return false;
    return true;
}

export function CreateWearablePermissionAuditLogDtoFromJSON(json: any): CreateWearablePermissionAuditLogDto {
    return CreateWearablePermissionAuditLogDtoFromJSONTyped(json, false);
}

export function CreateWearablePermissionAuditLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWearablePermissionAuditLogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'providerCode': json['providerCode'],
        'eventType': json['eventType'],
        'enabled': json['enabled'],
        'permissionStatus': json['permissionStatus'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function CreateWearablePermissionAuditLogDtoToJSON(json: any): CreateWearablePermissionAuditLogDto {
    return CreateWearablePermissionAuditLogDtoToJSONTyped(json, false);
}

export function CreateWearablePermissionAuditLogDtoToJSONTyped(value?: CreateWearablePermissionAuditLogDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'providerCode': value['providerCode'],
        'eventType': value['eventType'],
        'enabled': value['enabled'],
        'permissionStatus': value['permissionStatus'],
        'metadata': value['metadata'],
    };
}

